import { axios } from '@Root/API'

export const edit = (entryProfileId, id, payload) => {
	return axios.put(`student-registration/${entryProfileId}/qualification-award/${id}`, payload)
}
